const tr = {
  nav: {
    dashboard: "Dashboard",
    cari: "Cari Yönetimi",
    stok: "Stok Yönetimi",
    sepet: "Sepet",
    stokHareketleri: "Stok Hareketleri",
    siparisler: "Siparişler",
    faturalar: "Faturalar",
    kasaBanka: "Kasa / Banka",
    cekSenet: "Çek / Senet",
    raporlar: "Raporlar",
    excelImport: "Excel İçe Aktar",
    marjKontrolu: "Marj Kontrolü",
    kullanicilar: "Kullanıcılar",
    ayarlar: "Ayarlar",
    logout: "Çıkış Yap",
  },
  common: {
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    create: "Oluştur",
    search: "Ara",
    filter: "Filtre",
    all: "Tümü",
    loading: "Yükleniyor...",
    noData: "Kayıt bulunamadı",
    confirm_delete: "Silmek istediğinizden emin misiniz?",
    yes: "Evet",
    no: "Hayır",
    total: "Toplam",
    page: "Sayfa",
    new: "Yeni",
    export_excel: "Excel İndir",
    saving: "Kaydediliyor...",
    close: "Kapat",
  },
  labels: {
    code: "Kod",
    name: "Ad",
    date: "Tarih",
    amount: "Tutar",
    status: "Durum",
    description: "Açıklama",
    document_no: "Belge No",
    debit: "Borç",
    credit: "Alacak",
    balance: "Bakiye",
    due_date: "Vade Tarihi",
    bank: "Banka",
    type: "Tür",
    account: "Hesap",
    currency: "Para Birimi",
    price: "Fiyat",
    quantity: "Miktar",
    unit: "Birim",
    brand: "Marka",
    note: "Not",
  },
  status: {
    beklemede: "Beklemede",
    onaylandi: "Onaylandı",
    hazirlaniyor: "Onaylandı",
    sevkiyat: "Onaylandı",
    tamamlandi: "Tamamlandı",
    iptal: "İptal",
    tahsil_edildi: "Tahsil Edildi",
    iade: "İade",
    ciro_edildi: "Ciro Edildi",
    aktif: "Aktif",
    pasif: "Pasif",
  },
  reports: {
    title: "Raporlar",
    cari_bakiye: "Cari Bakiye",
    stok_degeri: "Stok Değeri",
    siparis: "Sipariş Raporu",
    yaslandirma: "Borç Yaşlandırma",
    kasa_banka: "Kasa / Banka",
    date_range: "Tarih Aralığı",
    start_date: "Başlangıç",
    end_date: "Bitiş",
    bucket_30: "0-30 gün",
    bucket_60: "31-60 gün",
    bucket_90: "61-90 gün",
    bucket_90p: "90+ gün",
  },
  kasa: {
    title: "Kasa / Banka",
    account_name: "Hesap Adı",
    account_type: "Hesap Türü",
    kasa: "Kasa",
    banka: "Banka",
    new: "Yeni Kayıt",
    total_kasa: "Toplam Kasa",
    total_banka: "Toplam Banka",
    grand_total: "Genel Toplam",
  },
  cek: {
    title: "Çek / Senet",
    alacakli_cek: "Alacaklı Çek",
    borclu_cek: "Borçlu Çek",
    alacakli_senet: "Alacaklı Senet",
    borclu_senet: "Borçlu Senet",
    new: "Yeni Çek/Senet",
    portfolio: "Portföy",
  },
};

export default tr;
